// plugins/dateHydrator.js
export default (store) => {
    const rehydrateDates = (obj, keys) => {
        keys.forEach(key => {
            if (obj[key] && typeof obj[key] === 'string') {
                const date = new Date(obj[key]);
                if (!isNaN(date)) obj[key] = date;
            }
        });
    };

    store.subscribe((mutation, state) => {
        if (mutation.type === 'RESTORE_MUTATION') {
            rehydrateDates(state.promo.form, ['started_at', 'expired_at']);
        }
    });

    // Run once at init
    rehydrateDates(store.state.promo.form, ['started_at', 'expired_at']);
};
